import { render, staticRenderFns } from "./FormControlMProductsProductsTypeId.vue?vue&type=template&id=af9d467c&scoped=true"
import script from "./FormControlMProductsProductsTypeId.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlMProductsProductsTypeId.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FormControlMProductsProductsTypeId.vue?vue&type=style&index=0&id=af9d467c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af9d467c",
  null
  
)

export default component.exports